import ProjectInvitation from '@projectMembers/models/projectInvitation';
import Text from '@ui/components/Text/Text';
import { Avatar, Group, Stack } from '@mantine/core';
import pendingInviteAvatar from 'src/assets/img/pending-invite.png';

import ProjectMemberRoleSelector from '../ProjectMemberRoleSelector/ProjectMemberRoleSelector';
import styles from './ProjectInvitationListItem.module.scss';

type ProjectInvitationListItemProps = {
	invitation: ProjectInvitation;
	onDelete?: ( invitation: ProjectInvitation ) => void;
	showDelete?: boolean;
};

const ProjectInvitationListItem = ( {
	invitation,
	onDelete,
	showDelete = false
}: ProjectInvitationListItemProps ) => (
	<Group position="apart" className={styles.ProjectInvitationListItem}>
		<Group>
			<Avatar size={34} radius="xl" src={pendingInviteAvatar} />
			<Stack spacing={0}>
				<Text variant="body-bold">Pending Invite</Text>
				<Text color="dark.3">{invitation.email}</Text>
			</Stack>
		</Group>
		<ProjectMemberRoleSelector
			selectedRole={invitation.role}
			roleOptions={[]}
			readonly={!showDelete}
			showRoles={false}
			showDelete={showDelete}
			onDelete={() => onDelete?.( invitation )}
		/>
	</Group>
);

export default ProjectInvitationListItem;
